import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/UserManager`;;

function paramsToStringList(params) {
  let stringparams = "?";
  Object.entries(params).map(([key, value]) => {
    if (value != undefined && value != null)
      stringparams = stringparams + key + "=" + value + "&";
  })
  stringparams = stringparams.substr(0, stringparams.length - 1);
  return stringparams;
}

const ApiUserManager = {
  getAllAdminUsers: (params) => {
    const url = `${baseServiceUrl}/getAllAdminUsers` + paramsToStringList(params);
    return ServiceApi.get(url, params);
  },
  getAllSiteUsers: (params) => {
    const url = `${baseServiceUrl}/getAllSiteUsers` + paramsToStringList(params);
    return ServiceApi.get(url, params);
  },
  getAllUsersWithRoleNames: (params) => {
    const url = `${baseServiceUrl}/getAllUsersWithRoleNames`;
    return ServiceApi.get(url, params);
  },
  getUserById: (params) => {
    const url = `${baseServiceUrl}/getUserById?id=${params.id}`;
    return ServiceApi.get(url, params);
  },
  updateUser: (params) => {
    const url = `${baseServiceUrl}/updateUser`;
    return ServiceApi.put(url, params);
  },
  updateUserSite: (params) => {
    const url = `${baseServiceUrl}/updateUserSite`;
    return ServiceApi.put(url, params);
  },
  createUsers: (params) => {
    const url = `${baseServiceUrl}/createUser`;
    return ServiceApi.post(url, params);
  },
  updateUserActive: (params) => {
    const url = `${baseServiceUrl}/updateUserActive`;
    return ServiceApi.put(url, params);
  },
  deleteUser: (params) => {
    const url = `${baseServiceUrl}/deleteUser?id=${params.id}`;
    return ServiceApi.delete(url, params);
  },
  getUserClaimsByUserId: (params) => {
    const url = `${baseServiceUrl}/getUserClaimsByUserId?userId=${params.userId}`;
    return ServiceApi.get(url, params);
  },
  updateUserAgentClaims: (params) => {
    const url = `${baseServiceUrl}/updateUserAgentClaims`;
    return ServiceApi.put(url, params);
  },
  updateUserName: (params) => {
    const url = `${baseServiceUrl}/updateUserName`;
    return ServiceApi.put(url, params);
  },
};

export default ApiUserManager;
